class HbsOrderDetayDTO {
    id: number = 0;
    orderId?: number = null;
    grupId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    onayli?: string = "H";
    onayTarih?: string = null;
    onayKullanici?: number = null;
}
export default HbsOrderDetayDTO;